<template>
  <div class="container-fluid">
    <div v-if="boot._id" class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ boot.BootName }}</h3>
            <p class="text-center">{{ boot.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div v-if="boot.imageUrl" class="text-center mb-3">
              <img :src="boot.imageUrl" alt="" style="max-width: 100%; max-height: 160px; object-fit: contain;" />
            </div>
            <div class="form-group px-3">
              <label class="form-control-label">تصویر نمایشی (ادمین)</label>
              <input type="file" class="form-control" accept="image/*" @change="imageSelected" />
              <button
                v-if="imageFile"
                type="button"
                class="btn btn-gradient-01 btn-sm mt-2 w-100"
                @click="uploadImage"
              >
                آپلود تصویر
              </button>
            </div>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات کفش</h4>
          </div>
          <div class="widget-body">
            <form id="bootForm" class="form-horizontal">
              <!-- boot english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام کفش</label>
                <div class="col-lg-6">
                  <input type="text" name="BootName" class="form-control" :value="boot.BootName" />
                </div>
              </div>

              <!-- boot ground -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام زمین</label>
                <div class="col-lg-6">
                  <!-- <input type="text" name="bootName" class="form-control" :value="boot.BootName" /> -->
                  <select name="BootGround" class="form-control" id="">
                    <option
                      v-for="ground in grounds"
                      :key="ground._id"
                      :value="ground._id"
                      :selected="ground._id == boot.BootGround._id"
                    >
                      {{ ground.groundName }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- bootIndex -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">
                  ایندکس کفش در اپلیکیشن (این مورد باید با اپلیکیشن سازگار باشد، تغیرش ندهید)
                </label>
                <div class="col-lg-6">
                  <input type="number" name="BootIndex" class="form-control" :value="boot.BootIndex" />
                </div>
              </div>
              <!-- boot min level -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد برد مورد نیاز</label>
                <div class="col-lg-6">
                  <input
                    type="number"
                    name="minWinToAchieve"
                    class="form-control"
                    min="1"
                    :value="boot.minWinToAchieve"
                  />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت کفش</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="boot.isAvailable">فعال</option>
                    <option value="false" :selected="!boot.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <!-- is default -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">کفش دیفالت</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isDefault" id="" :checked="boot.isDefault" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/boots">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootService from '../../../../services/boot';
import groundService from '../../../../services/ground';
export default {
  name: 'bootdetail',
  data() {
    return {
      boot: {},
      grounds: [],
      imageFile: null,
    };
  },
  created() {
    this.getboot();
    this.getGrounds();
  },
  methods: {
    async getGrounds() {
      try {
        const grounds = await groundService.getAllGrounds({});
        this.grounds = grounds;
      } catch (err) {
        console.log(err);
      }
    },
    async getboot() {
      try {
        const boot = await bootService.getBootById(this.$route.query.id);
        console.log(boot);
        this.boot = boot;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('bootForm');
      const body = {
        _id: this.boot._id,
        BootName: form.BootName.value,
        BootGround: form.BootGround.value,
        BootIndex: form.BootIndex.value,
        minWinToAchieve: form.minWinToAchieve.value,
        isAvailable: form.isAvailable.value == 'true',
        isDefault: form.isDefault.checked,
      };
      try {
        await bootService.updateBoot(body);
        this.getboot();
        window.notif({ isError: false, mssg: 'بروز رسانی انجام شد' });
      } catch (err) {
        console.log(err);
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }

      console.log(body);
    },

    imageSelected(e) {
      this.imageFile = e.target.files[0] || null;
    },

    async uploadImage() {
      if (!this.imageFile) {
        return window.notif({ isError: true, mssg: 'تصویری انتخاب نشده است' });
      }
      const fileSizeMb = this.imageFile.size / 1024 / 1024;
      if (fileSizeMb > 2) {
        return window.notif({ isError: true, mssg: 'حجم فایل زیاد است (حداکثر ۲ مگابایت)' });
      }
      try {
        await bootService.uploadBootImage(this.boot._id, this.imageFile);
        this.imageFile = null;
        await this.getboot();
        window.notif({ isError: false, mssg: 'تصویر آپلود شد' });
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی در آپلود تصویر پیش آمده' });
      }
    },
  },
};
</script>
